import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
  bottomNavigation: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: "#FFF",
  },
  icon: {
    width: 30,
    height: 30,
  },
  label: {
    fontSize: "12px",
    textAlign: "center",
    marginTop: 1,
  },
  navAction: {
    maxWidth: "25%", // Adjust this based on the number of items
    flexGrow: 1,
    padding: "2px",
  },
  activeNavAction: {
    backgroundImage: "url('path_to_active_image')",
    color: "#000",
    filter: "brightness(0.5) saturate(0%)",
  },
}));

const BottomNav = ({ navItems }) => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <BottomNavigation
      className={classes.bottomNavigation}
      style={{ height: "60px", zIndex: 9999 }}
    >
      {navItems.map((item, index) => (
        <BottomNavigationAction
          key={index}
          className={`${classes.navAction} ${
            location.pathname === item.to ? classes.activeNavAction : ""
          }`}
          showLabel
          icon={
            <img
              src={item.icon}
              alt={item.label}
              className={classes.icon}
              style={{ marginTop: "10px" }}
            />
          }
          label={
            <Typography
              variant="body2"
              className={classes.label}
              style={{ opacity: 1, fontSize: "10px" }}
            >
              {t(item.label)}
            </Typography>
          }
          component={Link}
          to={item.to}
        />
      ))}
    </BottomNavigation>
  );
};

export default BottomNav;
